import webBiLogger from '@wix/web-bi-logger';
import { bookingsEditorScript } from '@wix/bi-logger-wixboost-ugc/v2';
import { bookingsPlatformEditor3MyBusinessClickSrc16Evid80 } from '@wix/bi-logger-bookings-data/v2';

const logger = webBiLogger.factory().logger();

export const BI_TAB_MY_BOOKING = 'My Bookings';
export const BI_COMPONENT_APP_ACTION = 'app action';

export enum Actions {
  BOOKINGS_INSTALLATION = 'bookings-installation',
  MEMBERS_AREA_INSTALLATION = 'members-area-installation',
  ECOM_INSTALLATION = 'ecom-installation',
  CREATE_EDITOR_SCRIPT = 'create-editor-script',
  EDITOR_READY = 'editor-ready',
  EDITOR_READY_CALLBACK = 'editor-ready-callback',
  CART_INSTALLATION = 'cart-installation',
  MARK_CART_ENABLED = 'mark-cart-enabled',
  FIX_SITE = 'fix-site',
  ECOM_SELF_MIGRATION = 'ecom-self-migration',
  APP_INSTALLED = 'app-installed',
  APP_REMOVED = 'app-removed',
  MIGRATE = 'migrate',
  HANDLE_ACTION = 'handle-action',
  GET_APP_MANIFEST = 'get-app-manifest',
  ON_EVENT = 'on-event',
}

export type ReportBi = {
  msid?: string;
  origin?: string;
  isFirstInstall?: boolean;
  actionType: Actions;
  actionSucceed: boolean;
  errorMessage?: string;
};

export const reportBi = (input: ReportBi) => {
  logger.report(bookingsEditorScript(input));
};

export const getErrorInfo = (
  error: any,
): {
  action: Actions;
  message?: string;
  stack?: string;
} => {
  return {
    action: Actions.EDITOR_READY,
    message: error?.message ? error.message : JSON.stringify(error),
    stack: error?.stack,
  };
};

export interface ManageBookingsClickParams {
  appId: string;
  component: string;
  element: string;
  tab: string;
}

export const reportManageBookingsClick = ({
  appId,
  component,
  element,
  tab,
}: ManageBookingsClickParams) => {
  logger.report(
    bookingsPlatformEditor3MyBusinessClickSrc16Evid80({
      appId,
      component,
      element,
      tab,
    }),
  );
};

export interface ReportEditorActionParams {
  appId: string;
  component: string;
  element: string;
}

export const reportEditorAction = ({
  appId,
  component,
  element,
}: ReportEditorActionParams) => {
  reportManageBookingsClick({
    appId,
    component,
    element,
    tab: BI_TAB_MY_BOOKING,
  });
};
